<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
        v-if="total>0"
      >
        <span style="padding:5px;">Total Records:</span>
        <b>{{total}}</b>

      </b-col>
      <b-col lg="12">
        <b-table v-if="!message" style="background:#3a4149" :items="data" :fields="fields" title="Search Result">
          <template v-slot:cell(fnsid)="row">
            <a v-bind:href="customerReport + row.item.fnsid">{{ row.item.fnsid }}</a>
          </template>
        </b-table>
        <span v-else> {{ message }} </span>
        <div v-show="loading && !message" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import cTable from "./Table.vue";
import { formatUSDate } from '../../shared/formater';

export default {
  name: "tables",
  components: { cTable },
  data: () => {
    return {
      loading: false,
      total: null,
      message: null,
      data: [],
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "fnsra", label: "RANUM", sortable: true },
        { key: "sernm", label: "Serial#" },
        { key: "pMake", label: "Manufacturer" },
        { key: "pMode", label: "Model" },
        { key: "shipDate", label: "Ship Date", formatter: (value, key, item) => {
            return item.shipDate ? item.shipDate.slice(5, 7) + '/' + item.shipDate.slice(8, 10) + '/' + item.shipDate.slice(0, 4) : null
          } },
        { key: "locat", label: "Location" },
        { key: "price", label: "Price" },
      ],
      customerReport: process.env.VUE_APP_TRACKER_URL + 'tracker_private/includes/customerHarReportPublic.php?ftrack='
    }
  },
  watch: {
    $route (to, from) {
      this.fetchData()
    }
  },
  methods: {
    formatUSDate,

    fetchData() {
      this.message = null;
      this.loading = true;
      let params = {};
      params = {
        type: this.$route.query.type,
        value: this.$route.query.value
      };
      this.$http
        .get(process.env.VUE_APP_TRACKER_URL + "api/har/tables/search.php", { params })
        .then(
          res => {
            if(res.data.message) {
              this.message = 'Nothing found.'
            } else {
              this.data = res.data.records;
              console.log(res.data);
              this.total = res.data.records.length;
              this.loading = false;
            }
          },
          err => {
            console.log(err);
          }
        );
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>
